import { render, staticRenderFns } from "./AiAnalysis.vue?vue&type=template&id=3b8c3534&scoped=true"
import script from "./AiAnalysis.vue?vue&type=script&lang=js"
export * from "./AiAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AiAnalysis.vue?vue&type=style&index=0&id=3b8c3534&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c3534",
  null
  
)

export default component.exports